import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineComponent, reactive, computed } from 'vue'
import NAVTOP from './component/navTop/navTop.vue'
import NAVLEFT from './component/navLeft/navLeft.vue'
import AsideTop from './component/navTop/AsideTop.vue'
import { gaEvent } from '@/utils/format'

// import { userInfo } from './component/config/deviceInfo'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'nav',
  setup(__props) {

let store = useStore()
let state = reactive({
  isSidebarNavCollapse: computed(
    () => store.getters.getIsSidebarNavCollapse
  ),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ navCollapsed: _unref(state).isSidebarNavCollapse })
  }, [
    _createVNode(AsideTop),
    _createVNode(NAVTOP)
  ], 2))
}
}

})